import { Workbox } from 'workbox-window';
import { Button as MuiButton } from '@mui/material';
import { Snackbar } from '@client/components/globals/Snackbar';
import { trackAnalytics } from '@client/intercom';
import { AnalyticsEvents } from '@sda/interfaces/queue/analytics';

if (process.env.NODE_ENV !== 'development' && 'serviceWorker' in navigator) {
  // Implementation courtesy of Google
  // https://developers.google.com/web/tools/workbox/guides/advanced-recipes#offer_a_page_reload_for_users
  const wb = new Workbox('/service-worker.js');

  wb.addEventListener('waiting', () => {
    Snackbar.show({
      autoHideDuration: null,
      severity: 'primary',
      body: 'A new version of Side Door is available',
      action: (
        <MuiButton
          color="primary"
          id="sda-snackbar-new-version-available-refresh-button"
          variant="contained"
          onClick={() => {
            console.log('refresh requested');
            console.log('workbox instance', wb);

            trackAnalytics(AnalyticsEvents.RELOADED_APP);

            wb.addEventListener('controlling', () => {
              window.location.reload();
            });

            // Force the page to reload if the service worker doesn't for some reason
            // TODO - Figure out why the service worker isn't always reloading on command
            setTimeout(() => window.location.reload(), 500);

            wb.messageSW({ type: 'SKIP_WAITING' });
          }}
        >
          Refresh
        </MuiButton>
      ),
    });
  });

  wb.register();
}
